module.exports = __webpack_public_path__ + "shock-absorber.png?3b86676eb80c28292bd5a68d99b6bf3b";